module.exports = __webpack_public_path__ + "static/img/customerLogin.45e0110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/customerLogin.png
// module id = NWQI
// module chunks = 1